export default __webpack_public_path__ + "static/media/RPBackground.61572710.png";